import { Drawer, LinearProgress } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Button } from '../../../../components/button/Button';
import { FlyoutFooter } from '../../../../components/flyout-components/FlyoutFooter';
import { StatusCode } from '../../../../utils/api';
import { PlanningCreateStatus, PlanningCreateStatusMetadata } from '../../../../production/models/enums/planning-create-status';
import { CreateProductionRunDelivery } from '../../../../production/models/metrics/create-production-run-delivery';
import { UnplannedDeliveryMetricsGroup } from '../../../../production/models/metrics/unplanned-delivery-metrics-group';
import { ProductionSvc } from '../../../../production/service';

interface IProps {
    isOpen: boolean;
    onClose: any;
    taskGroups: any[];
}

export const CreateRunForDeliveryFlyout = (props : IProps) => {

    const [service] = React.useState(new ProductionSvc());
    const [blockClose, setBlockClose] = React.useState(false);
    const [taskCopy, setTaskCopy] = React.useState<UnplannedDeliveryMetricsGroup[]>([]);
    const [wasSuccess, setWasSuccess] = React.useState(false);
    const [madeAttempt, setMadeAttempt] = React.useState(false);
    
    /**
     * When isOpen toggles, refresh data
     */
    React.useEffect(() => {
        if (props.isOpen) {
            const t = cloneDeep(props.taskGroups);
            setTaskCopy(t);
            setWasSuccess(false);
            setMadeAttempt(false);
            setBlockClose(false);            
        }
    }, [props.isOpen]);

    /**
     * Fire our request to create a production run for these pickups
     */
     const createRuns = async () => {
        setBlockClose(true);
        setMadeAttempt(true);

        let successes = 0;
        for (let i = 0; i < taskCopy.length; i++) {

            if (taskCopy[i].createSuccess === PlanningCreateStatus.Success) {
                successes++;
                continue;
            }

            taskCopy[i].isLoading = true;
            setTaskCopy([...taskCopy]);

            const req = new CreateProductionRunDelivery();            
            req.shipmentId = taskCopy[i].shipmentId;                
            
            const result = await service.createProductionRunForDelivery(req);
            taskCopy[i].isLoading = false;

            if (result.status === StatusCode.Success) {
                taskCopy[i].createSuccess = PlanningCreateStatus.Success;
                successes++;
            }
            else {
                taskCopy[i].createSuccess = PlanningCreateStatus.Failure;
            }
            
            setTaskCopy([...taskCopy]);
        }

        successes === taskCopy.length ? setWasSuccess(true) : setWasSuccess(false);
        setBlockClose(false);

    };

    const closeFlyout = () => {
        props.onClose(madeAttempt);
    };

    return (
        <Drawer
            anchor="right"
            onClose={ closeFlyout }
            open={props.isOpen}>
            <div className="stop-action-drawer stop-action-reorder-route production-module-flyout">
                <div className="row">
                    <div className="col">
                        <h1>Create Production Runs</h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <p>Confirm your shipment selections and press the 'Create' button to create a new production run for these shipments.</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        {
                            taskCopy
                                ? <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Shipment ID</th>
                                            <th>Shipment Name</th>
                                            <th>Activity</th>
                                        </tr>
                                    </thead>
                                    <tbody>                                            
                                    {
                                        taskCopy.map((itm : UnplannedDeliveryMetricsGroup, idx: number) => 
                                            <tr key={`delivery-task-${idx}`} className={`delivery-task-${idx}`}>
                                                <td>{ itm.shipmentId }</td>
                                                <td>{ itm.shipmentName }</td>
                                                <td>
                                                    {
                                                        itm.isLoading
                                                            ? <LinearProgress
                                                                classes={{
                                                                    colorPrimary: 'btn-progress-indicator-primary',
                                                                    barColorPrimary: 'btn-progress-indicator-barcolor'
                                                                }} 
                                                            />
                                                            : PlanningCreateStatusMetadata[itm.createSuccess].display                                                                    
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                            </table>
                            : <div>No Tasks Selected.<br/>How did you even get here?</div>
                        }                        
                    </div>
                </div>  
                         
                <CSSTransition
                    in={ wasSuccess }
                    timeout={300}
                    classNames="productionOrderMenu"
                    unmountOnExit>
                        <div className="row">
                            <div className="col create-success-message">
                                <p>All runs have been created.  You can head to the scheduling page to view them.</p>
                                <br/>
                                <i className="la la-check-circle" />
                            </div>
                        </div>
                </CSSTransition>
               
                <FlyoutFooter>
                    <div className="row">
                        <div className="col">                            
                            {
                                wasSuccess
                                    ? <Button
                                        text="Close"
                                        classes="action"
                                        testID="close-planning-flyout"
                                        onBtnClick={ closeFlyout } />
                                    : <Button
                                        text="Create Runs"
                                        classes="attention"
                                        testID="create-planning-flyout"
                                        onBtnClick={ createRuns } />
                            }                            
                        </div>
                    </div>
                </FlyoutFooter>                    

            </div>
        </Drawer>
    );

};
